import { useFormikContext } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Switch } from '@@/form-components/SwitchField/Switch';
import { FormSection } from '@@/form-components/FormSection';

import { KubernetesSecurityFormValues } from './types';

export function SecuritySection() {
  const { values, setFieldValue } =
    useFormikContext<KubernetesSecurityFormValues>();

  return (
    <FormSection title="Security">
      <div className="row mb-10">
        <p className="text-muted text-xs">
          By default, all the users have access to the default namespace. Enable
          this option to set accesses on the default namespace.
        </p>
        <FormControl
          inputId="restrict-default-namespace"
          label="Restrict access to the default namespace"
          size="large"
        >
          <Switch
            id="restrict-default-namespace"
            data-cy="restrict-default-namespace-toggle"
            name="restrictDefaultNamespace"
            className="space-right"
            checked={values.restrictDefaultNamespace || false}
            onChange={(value) =>
              setFieldValue('restrictDefaultNamespace', value)
            }
          />
        </FormControl>
      </div>

      <FormControl
        inputId="restrict-secrets"
        label="Restrict secret contents access for non-admins (UI only)"
        tooltip="This hides the ability to view or edit in the UI the contents of secrets that a non-admin user did not create themselves but does not prevent it via the command line."
        size="large"
      >
        <Switch
          id="restrict-secrets"
          data-cy="restrict-secrets-toggle"
          name="restrictSecrets"
          className="space-right"
          checked={values.restrictSecrets || false}
          onChange={(value) => setFieldValue('restrictSecrets', value)}
        />
      </FormControl>
    </FormSection>
  );
}
